module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAA3ElEQVRoQ+2aQQ6DMAwE40eTa+mVPDpVWhBRb2Eqpa2GI2JtZXdt2RGRwJNzXmutt4i4b9u2joQi2D5PjCR9/3ZZlnq8K6UMxSJYD3AwQFgkWBVQgZSSFtptMNT6bKMdA1pIC8FOooX+xkLHWEum0oYl0+jV3G2Mj96LVwPNOkDLG59QgCw0hLSnAiTAN2A9wGwVVEAFIANaCBKI4SqAKYQBVAASiOG/P8w5Tu8mmLbQEBOSxZxgvZ32dhreKWkhLaSFzipAwxzp5QRrEVvEFrFF/GKA/DJDsH0XegDkETyE+Uym9AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/community/un-full-screen.png
// module id = dKKM
// module chunks = 15